import { StoreAndGroupType } from '@/context/context.types';
import { Modifier } from '@/types/menus.types';
import { RowSelectionState } from '@tanstack/react-table';

export function getModifiersFromRowSelection(selectedRows: RowSelectionState, modifiers: Modifier[]): Modifier[] {
  return Object.keys(selectedRows)
    .map((index) => modifiers[Number(index)])
    .filter((modifier): modifier is Modifier => modifier != null);
}

export function getSelectedStoreGroupNames(storesAndGroups: StoreAndGroupType | undefined): string[] {
  if (!storesAndGroups) return [];

  if (storesAndGroups.origin === 'tab-stores-groups') {
    return storesAndGroups.storeGroups?.map((group) => group.storeGroup) ?? [];
  }

  if (storesAndGroups.origin === 'tab-store') {
    const names = new Set<string>();
    storesAndGroups.stores?.forEach((store) => {
      if (store.storeGroup) names.add(store.storeGroup);
    });
    return Array.from(names);
  }

  return [];
}

export function getModifiersRowFingerprint(modifiers: Modifier[]): string {
  return modifiers
    .map((modifier) => `${modifier.slotId}:${modifier.modifierId}:${modifier.modifierWeightId}`)
    .join('|');
}
